<template>
  <CDropdown
    v-if="contentAnnotation"
    :options="annotationMenu"
    placement="top-start"
    :show="contentAnnotation.isVisibleMenu"
    trigger="manual"
    @clickoutside="handleAnnotationOutsideClick"
    @select="contentAnnotation.handleAnnotationSelect"
  >
    <CButton
      ref="annotationMenuRef"
      v-tooltip="t('canvasUI.canvasBuilder.components.annotationMenu')"
      :circle="circle"
      class="w-11 h-11"
      secondary
      size="large"
      @click="contentAnnotation.toggleMenu()"
    >
      <template #icon>
        <CIcon fixed-width :icon="contentAnnotation.activeToolIcon" size="16px" />
      </template>
    </CButton>
  </CDropdown>
</template>

<script setup lang="tsx">
import CDropdown from '@lib/components/CDropdown/CDropdown.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { computed, ref } from 'vue'
import type { DropdownMixedOption } from 'naive-ui/es/dropdown/src/interface'
import useCanvas from '@canvas-builder/composables/useCanvas.ts'
import { useI18n } from 'vue-i18n'

defineProps<{
  circle?: boolean
}>()

const annotationMenuRef = ref<InstanceType<typeof CButton> | null>(null)
const { contentAnnotation } = useCanvas()
const { t } = useI18n()

const handleAnnotationOutsideClick = (event: Event) => {
  const annotationMenuElement = annotationMenuRef.value?.$el

  if (
    annotationMenuElement &&
    (annotationMenuElement.contains(event.target as HTMLElement) || annotationMenuElement === event.target)
  ) {
    return
  }

  if (contentAnnotation.value) {
    contentAnnotation.value.showMenu(false)
  }
}

const annotationMenu = computed<DropdownMixedOption[]>(() => {
  const menuItems = []

  for (const [key, tool] of Object.entries(contentAnnotation.value?.markerTools ?? {})) {
    if ('dividerBefore' in tool && tool.dividerBefore) {
      menuItems.push({ key: `d-${key}`, type: 'divider' })
    }

    menuItems.push({
      label: () => <div class="font-size-4">{tool.translationKey}</div>,
      key,
      icon: () => <CIcon icon={tool.icon} />,
    })
  }

  return menuItems
})
</script>
